import React from 'react'
import { useStyles } from './Installments.styles'
import { useStyles as usePricingStyles } from '../Sections.styles'
import { Divider } from '@mui/material'
import { calculateBuyerPrice } from '@labrav/common'
import {
  InstallmentScheduleItem,
  ShowInvoiceDate,
} from '../../../MicrosoftViewPricing/MicrosoftInstallments/MicrosoftInstallments'
import { DisplayValueData } from '../../../PrivateOfferFormV2/AzureOffer/Plan/PlanRow/MeteringDimensions/MeteringDimensions'

interface InstallmentsProps {
  schedule?: InstallmentScheduleItem[]
  markupPercentage?: number
  isISV?: boolean
}

export const Installments: React.FC<InstallmentsProps> = ({
  schedule = [],
  markupPercentage,
  isISV = false,
}) => {
  const { classes } = useStyles()
  const { classes: pricingClasses } = usePricingStyles()
  const getPriceToISV = (item: InstallmentScheduleItem): number | null => {
    return item.pricePerPaymentInUsd || null
  }
  const getPriceFromBuyer = (item: InstallmentScheduleItem): number | null => {
    return calculateBuyerPrice({
      wholesalePrice: (item.pricePerPaymentInUsd as number) || 0,
      percentage: markupPercentage || 0,
    })
  }
  return (
    <div
      className={classes.container}
      data-testid="microsoft-installments-container"
    >
      <div
        className={pricingClasses.subHeading}
        data-testid="installment-schedule-heading"
      >
        Installment Schedule ({schedule?.length})
      </div>
      <Divider />
      <div className={classes.table} data-testid="installment-schedule-table">
        <div className={classes.row} data-testid="installment-table-header">
          <div className={classes.headerCell}>Invoice date</div>
          <div className={classes.headerCell}>
            {!isISV ? 'Price to ISV' : 'Installment amount'}
          </div>
          {!isISV && <div className={classes.headerCell}>Price from buyer</div>}
        </div>
        {schedule.map((item, index) => (
          <div
            key={index}
            className={classes.row}
            data-testid={`installment-row-${index}`}
          >
            <ShowInvoiceDate item={item} />
            <div
              className={classes.cell}
              data-testid={`installment-price-to-isv-${index}`}
            >
              <DisplayValueData
                isPrice
                id="priceToISV"
                value={getPriceToISV(item) || 0}
                precision={5}
              />
            </div>
            {!isISV && (
              <div
                className={classes.cell}
                data-testid={`installment-price-from-buyer-${index}`}
              >
                <DisplayValueData
                  isPrice
                  id="priceFromBuyer"
                  value={getPriceFromBuyer(item) || 0}
                  precision={5}
                />
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  )
}
